import HttpResponse from "../../../../../utils/http/http.response";

export enum OrderCargoOrderActiveListResponseItemStatus {
  CANDIDATURE = "CANDIDATURE",
  IN_PROGRESS = "IN_PROGRESS",
  PENDING = "PENDING",
  PLANNED = "PLANNED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

export type OrderCargoOrderActiveListResponseItemProducer = {
  id: string | null;
  name: string;
};

export type OrderCargoOrderActiveListResponseItemConsumer = {
  id: string | null;
  name: string;
};

export type OrderCargoOrderActiveListResponseItemClient = {
  id: string | null;
  name: string;
};

export type OrderCargoOrderActiveListingResponseItemAttentions = {
  newSharedPost: boolean;
  newPlanEntryPost: boolean;
  cargoOrderEdit: boolean;
  cargoOrderCancel: boolean;
};

export type OrderCargoOrderActiveListResponseItem = {
  id: string;
  startTime: Date;
  startLat: number;
  startLon: number;
  humanId: number;
  rideAddresses: (string | string[])[];
  passengers: string[];
  dispatch: string;
  client: OrderCargoOrderActiveListResponseItemClient;
  taxiCorporations: string[];
  consumer: OrderCargoOrderActiveListResponseItemConsumer | null;
  producer: OrderCargoOrderActiveListResponseItemProducer;
  drivers: string[];
  push: boolean;
  status: OrderCargoOrderActiveListResponseItemStatus;
  externalId: string | null;
  attentions: OrderCargoOrderActiveListingResponseItemAttentions;
  slkStatus: boolean | null;
  fleetPartner: string | null;
  approvalDeadline: Date | null;
};

type OrderCargoOrderActiveListResponse = HttpResponse<
  OrderCargoOrderActiveListResponseItem[]
>;

export default OrderCargoOrderActiveListResponse;
